import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LobbyCentralViewsComponent } from './lobby-central-views.component';

const routes: Routes = [{ path: 'lobby-central-view', component: LobbyCentralViewsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LobbyCentralViewsRoutingModule { }
